export default "//cloud.imgsmail.ru/cloud.mail.ru/126090/img/build/errors/error-404.png";